let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iYHgz")).then(() => parcelRequire('eYr6k'));